export function getInitials(name?: string, maxLength = 2) {
  if (!name || name.length === 0) return "";
  const parts = name.split(/[\s,]+/);
  if (parts.length > maxLength) {
    parts.splice(maxLength);
  }
  return parts
    .map((part) => part[0])
    .join("")
    .toUpperCase();
}
